import React from 'react';
import ModalLayout from "./ModalLayout.react";
import { Crud_Catalogos, Crud_error } from '../herramientas/Crud_Catalogos';
import { Form, Grid, Card, Table, Alert,Button, Icon, Dimmer } from "tabler-react";
import { GetRoles } from "../herramientas/JWT";
import { TablePageable } from "../Helpers";
class Catalogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
              elementos: [],
              elemento: null,
           hiddenModals: false,
              readyData: false,
                message: "",
           ErrorMessage: [],
       showErrormessage: false,
           showMensajes: true,
                 search: "",
             pagination: [],
                 pagina: 1,
               pagesize: 200,
    };
    this.hiddenmodal= this.hiddenmodal.bind(this);
    this.pagination=[];
    this.ErrorMessage = "";
    this.ErrorMessageArray = [];
    this.catalogo = this.props.catalogo;
    this.catalogoTem = "";
    this.Catalogo_form = this.props.FCtlogo;
    this.tamanio = this.props.tamanio;
    this.fila= [];
    this.getMensage=false;
    this.elements=[];
  }
  componentWillMount=() =>{
  }
  componentDidMount = () => {
    Crud_Catalogos(this.props.catalogo, "get", "", "").then((returnVal) => {
      this.setState({ elementos: returnVal });
    }).catch(err =>{
      if( err.response ){
        this.setState({ showErrormessage: true });
        this.ErrorMessage = Crud_error(err.response.status, this.props.catalogo);
        this.ErrorMessageArray.push( <Alert type="danger" icon="alert-octagon" > {this.ErrorMessage} </Alert> );
        this.setState({ ErrorMessage: this.ErrorMessageArray });
      } else {
        this.setState({ showErrormessage: true });
        this.ErrorMessage = Crud_error(404, this.props.catalogo);
        this.ErrorMessageArray.push( <Alert type="danger" icon="alert-octagon"> {this.ErrorMessage} </Alert> );
        this.setState({ ErrorMessage: this.ErrorMessageArray });
      }
    });
  }
  hiddenmodal = () => {
    this.setState({ hiddenModals: !this.state.hiddenModals });
  }
  render() {
    return (
      <div>
        <Dimmer></Dimmer>
          <Grid.Col lg={12}>
            <div className= "m-3"></div>
            <div className="row">
              <div className="col col-12 col-sm-12 col-md-12 ">{ console.log(this.Catalogo_form)}
                <TablePageable
                  titulo={
                    <div className='row'>
                      <div className='col'><h5>{this.catalogo}</h5></div>
                      <div className='col'>
                        <span className="badge">
                            <ModalLayout
                              tamanio={this.tamanio}
                              hiddenModal={ this.state.hiddenModals }
                              Fclose={this.hiddenmodal}
                              title= "Nuevo"
                              //tamanio = {this.tamanio}
                              name= { <i className="fa fa-plus text-primary" style={{"font-size": "24px"}}></i>}
                              formulario= {
                                <this.Catalogo_form
                                  accion="nuevo"
                                  elementos={ null }
                                  catalogo= { this.props.catalogo }
                                />
                              }
                            />
                          </span>                        
                      </div>
                      <div className='col'>
                        <span className="badge">
                          <ModalLayout
                            tamanio={this.tamanio}
                            hiddenModal={ this.state.hiddenModals }
                            Fclose={this.hiddenmodal}
                            title= "Modificar"
                            //tamanio = {this.tamanio}
                            name= { <i className="fa fa-edit text-primary" style={{"font-size": "24px"}}></i>}
                            formulario= {
                              <this.Catalogo_form
                                accion="modificar"
                                elemento={ this.state.elemento }
                                catalogo= { this.props.catalogo }
                              />
                            }
                          />
                        </span>
                      </div>
                    </div>}
                  lista= { this.state.elementos }
                  columnas={this.props.columnas}
                  id= "id"
                  selected={(e)=>{ this.setState({ elemento: e}) }}
                  csvname= {this.catalogo}
                  //resaltarFuncion={(e)=> e.id ? true: false}
                  //resaltarColor={"rgba(58, 223, 149, 0.25)"}
                  paginacion={true}
                  elementosPorPagina={15}
                />
                <h3> {this.catalogo } </h3>{/*
                <Card title={ " " }isCollapsible={ false } isCollapsed={ false } // title={this.catalogo }
                      options={
                        <div className="row">
                          <div className="col col-3 col-sm-12 col-md-8 mt-3">
                            <Form.Input
                              className="mb-3"
                              icon="search"
                              placeholder="Buscar..."
                              position="append"
                              onChange={(e)=> this.setState({ search: e.target.value })}
                            />
                          </div>
                          <div className="col col-1 col-sm-12 col-md-2 mt-1" hidden={ !GetRoles().includes("root", "hola")}>
                            <span className="badge">
                              <ModalLayout
                                tamanio={this.tamanio}
                                hiddenModal={ this.state.hiddenModals }
                                Fclose={this.hiddenmodal}
                                title= "Nuevo"
                                //tamanio = {this.tamanio}
                                name= {<Button pill size="sm" outline color="primary"><Icon name="plus"/></Button>}
                                formulario= {
                                  <this.Catalogo_form
                                    accion="nuevo"
                                    elementos={ null }
                                    catalogo= { this.props.catalogo }
                                  />
                                }
                              />
                            </span>                        
                          </div>
                          <div className="col col-1 col-sm-12 col-md-2 mt-1" hidden={ !this.state.elemento || !GetRoles().includes("root", "hola")}>
                            <span className="badge">
                              <ModalLayout
                                tamanio={this.tamanio}
                                hiddenModal={ this.state.hiddenModals }
                                Fclose={this.hiddenmodal}
                                title= "Modificar"
                                //tamanio = {this.tamanio}
                                name= {<Button pill size="sm" outline color="primary"><Icon name="edit"/></Button>}
                                formulario= {
                                  <this.Catalogo_form
                                    accion="modificar"
                                    elemento={ this.state.elemento }
                                    catalogo= { this.props.catalogo }
                                  />
                                }
                              />
                            </span>
                          </div>
                        </div>
                      }
                    >
                      <Table cards={true} striped={true} responsive={true} className="table-center col-12" >
                        <Table.Header>
                          <Table.Row>
                            {this.props.columnas.map((c, index)=> <Table.ColHeader key= {c.columna} >{c.label}</Table.ColHeader>)}
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {
                            this.state.elementos
                              .filter(words => this.filtro(words) ).sort().map((elemento, index) =>
                              <Table.Row
                                style={
                                  {
                                    "background-color":
                                      this.state.elemento && this.state.elemento.id === elemento.id
                                        ? "rgba(29, 196, 247, 0.43)"
                                        : null
                                  }}
                                onClick={()=> this.setState({ elemento: elemento})}
                              >
                                {this.props.columnas.map((c, index)=> <Table.Col key={c.columna}>{elemento[c.columna]}</Table.Col>)}                            
                              </Table.Row>
                            )
                          }
                        </Table.Body>
                      </Table>
                </Card>*/}
              </div>
            </div>
            <div hidden={!this.state.showErrormessage}> {this.state.ErrorMessage} </div>
          </Grid.Col>
          { this.ErrorMessageArray }
      </div>
    );
  }
}
export default Catalogo;
